import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../service/api/api.service';
import { SioService } from '../../../service/sio/sio.service';
import { NotificationService } from '../../../service/notification/notification.service';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [NgSelectModule, RouterModule, CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  collapsedMenus: { [key: string]: boolean } = {};
  trackingInit: boolean = false;
  isDroitExiste = false;

  // Ajouter cette méthode dans la classe du composant
  checkDroits(itemActions: any[], userDroits: any[]): boolean {
    if (!itemActions || !userDroits) return false;
    return itemActions.some((action) =>
      userDroits.some((droit) => droit.id === action.id)
    );
  }

  constructor(
    public api: ApiService,
    public sio: SioService,
  ) { }
  ngOnInit(): void {
    this.listen_sio()
  }
  listen_sio(): void {
    this.sio.init_socket()

    this.sio.on_update((data: any) => {
      this.api.les_utilisateurs = data.map((un_utilisateur: any) => {
        // console.log('un_utilisateur = ', un_utilisateur);
        try {
          un_utilisateur.data_parsed = JSON.parse(un_utilisateur?.data||'[]');
        } catch (e) {
          console.log('Erreur de parsing JSON :', e);
          un_utilisateur.data_parsed = {};
        }
        // un_utilisateur.data = JSON.parse(un_utilisateur.data)
        if (un_utilisateur?.data_parsed?.user) {
          un_utilisateur.token_decoded = this.api.decode_token(
            un_utilisateur.token
          );

          un_utilisateur.titre =
            (un_utilisateur?.data_parsed?.user?.prenom
              ? un_utilisateur?.data_parsed?.user?.prenom
              : '') +
            (un_utilisateur?.data_parsed?.user?.nom
              ? ' ' + un_utilisateur?.data_parsed?.user?.nom
              : '');
        } else {
          un_utilisateur.titre = 'Inconnu';
        }
        // console.warn('utilisateur: ', un_utilisateur);

        return un_utilisateur;
      });
    });

   
    // this.initializeTracking();
  }

  async initializeTracking() {
    if (!this.trackingInit && this.api.infos.utilisateur) {
      this.trackingInit = true;
      setTimeout(() => {
        // console.log('🛰️ Socket =', this.sio.socket);
        // this.logService.init();
      }, 300); // facultatif, selon les besoins
    }
  }

  toggleMenu(menuHeader: string) {
    this.collapsedMenus[menuHeader] = !this.collapsedMenus[menuHeader];
  }
}
